import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import { QUERY_SETTINGS } from "../../service/ApolloClient/ApolloQueries";
import { client } from "../../service/ApolloClient/ApolloClient";
import SettingList from "../../components/Setting/List/SettingList";
import Loading from "../../components/UI/Loading/Loading";

class SettingListPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      data: null,
    };
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    client
      .query({
        query: QUERY_SETTINGS,
        fetchPolicy: "network-only",
      })
      .then((res) => {
        this.setState({
          data: res.data.settings,
          loading: false,
        });
      })
      .catch((err) => {});
  }

  render() {
    const { loading, data } = this.state;

    return (
      <Wrapper>
        <BreadcrumbsTemp
          items={[
            {
              title: "لیست تنظیمات",
              to: "/setting/list/",
            },
          ]}
        />

        <Grid container={true}>
          <Grid item xs={12}>
            {loading ? (
              <Loading />
            ) : data ? (
              <SettingList settings={data} title={"لیست تنظیمات"} />
            ) : (
              "load data"
            )}
          </Grid>
        </Grid>
      </Wrapper>
    );
  }
}

export default SettingListPage;
